"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApplicationInsightsReactPlugin = void 0;
var _applicationinsightsReactJs = require("@microsoft/applicationinsights-react-js");
var _ApplicationInsights = require("./ApplicationInsights");
var _isServerApplicationInsightsClient = require("./isServerApplicationInsightsClient");
const getApplicationInsightsReactPlugin = () => {
  const ai = _ApplicationInsights.ApplicationInsights.get();
  if ((0, _isServerApplicationInsightsClient.isServerApplicationInsightsClient)(ai)) {
    throw new Error('There is no react plugin on server for application insights');
  }
  const plugin = ai.config.extensions?.find(extension => extension instanceof _applicationinsightsReactJs.ReactPlugin);
  return plugin;
};
exports.getApplicationInsightsReactPlugin = getApplicationInsightsReactPlugin;
